export const optionCardStyle = {
    padding: '10px 2px 10px 2px',
    cursor: 'pointer',
    '&:hover': { backgroundColor: 'rgb(242, 242, 242)' },
    height: '100%',
};
